import type { SendReminder } from '../..'

export const getWaitTimestampExpression = (
  sendReminder: SendReminder | undefined,
  baseDate: string
): string => {
  const days = sendReminder?.duration.days ?? 0
  const offset = sendReminder?.type === 'BEFORE_DUE_DATE' ? -days : days

  return `(function() {
  var parts = ${baseDate}.split('-');
  var date = new Date(Date.UTC(Number(parts[0]), Number(parts[1]) - 1, Number(parts[2]) + (${offset})));
  function pad(value) { return value < 10 ? '0' + value : '' + value; }
  return date.getUTCFullYear() + '-' + pad(date.getUTCMonth() + 1) + '-' + pad(date.getUTCDate()) + ' 00:00 GMT+00:00';
}())`
}
